var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.classObj.up || _vm.classObj.down),expression:"classObj.up || classObj.down"}],staticClass:"updownpointer",class:_vm.classObj,on:{"click":function($event){_vm.onPointerClick()}}},[_c('i',{staticClass:"fas ",class:{
            'fa-angle-up': _vm.classObj.up,
            'fa-angle-down': _vm.classObj.down
        }})])}
var staticRenderFns = []

export { render, staticRenderFns }